import { useState, useEffect } from "react";

import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";

import { CloseX } from "components/utility/CloseX";
import { Loading } from "components/utility/Loading";
import { ModalTitle } from "components/utility/ModalTitle";
import { VSpace } from "components/utility/VSpace";

import { i18n } from "services/i18nService";
import { getUpsRates } from "services/sosInventoryService/sosApi";

import { UpsRatesTable } from "views/UpsShipments/UpsShipment/UpsRatesTable";
import { UpsTrademark } from "views/UpsShipments/UpsShipment/UpsTrademark";

export function UpsRatesDialog(props) {
  const { record, onClose, selectRate } = props;

  const [rates, setRates] = useState(null);

  useEffect(() => {
    async function _getRecord() {
      const response = await getUpsRates(record);
      setRates(response);
    }
    _getRecord();
  }, [setRates, record]);

  return (
    <Dialog open={true} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle
        sx={{
          backgroundColor: "dialogTitleBackground",
          borderBottom: "1px solid",
          borderBottomColor: "lineSeparatorMinor",
          padding: "0.5rem 1rem",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <ModalTitle label={i18n("upsShipment.UPSRates")} />
          <CloseX onClick={onClose} />
        </div>
      </DialogTitle>
      {!rates && <Loading />}
      <VSpace space={2} />
      <DialogContent>
        <UpsRatesTable rates={rates} selectRate={selectRate} />
        <UpsTrademark />
      </DialogContent>
      <DialogActions>
        <Button color="secondary" onClick={onClose}>
          {i18n("button.OK")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
